<template>
  <div class="pro-venue-header-container">
    <div class="bg-image">
      <!-- <img :src="getVenueImageUrl()" alt="" /> -->
      <div
        :style="{
          backgroundImage: getVenueBackgroundImageUrl(),
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }"
        class="lg:h-[440px] h-[164px]"
      ></div>
      <div class="bg-image--overlay"></div>
    </div>
    <div class="pro-venue-header">
      <div class="relative pro-venue-header--img">
        <img
          v-if="venueStore.details.has_provenue"
          src="@/assets/images/ic-pro-venues.svg"
          alt=""
          class="absolute inset-0 mx-auto px-[16px] mt-[10px] z-10"
        />
        <div class="relative venue-img-container">
          <img
            class="venue-img w-full object-cover"
            :src="getVenueImageUrl()"
            :alt="
              $t('wegow.profile.altDefaultImage', {
                element: venueStore.details?.name
              })
            "
          />
          <!-- Degradados superior e inferior -->
          <div class="gradient-top"></div>
          <div class="gradient-bottom"></div>
        </div>
        <!-- <img class="venue-img w-full" :src="getVenueImageUrl()" alt="" /> -->
        <div
          v-if="
            venueStore.details.has_provenue &&
              venueStore.details.provenue_details.spotify_url
          "
          class="spotify w-full lg:hidden flex flex-row gap-1 items-center absolute bottom-0 left-1/2 transform -translate-x-1/2 pl-[7px] mb-[10px]"
          @click="navigateToSpotifyLink()"
        >
          <img
            src="@/assets/images/ic-play-circle-topaz.svg"
            class="h-[16px]"
            :alt="$t('wegow.profile.alt.play')"
          />
          <span class="text-xs">Escuchar en</span>
          <img
            src="@/assets/images/ic-spotify-white.svg"
            class="h-[16px]"
            :alt="$t('wegow.profile.alt.spotify')"
          />
        </div>
      </div>
      <div class="pro-venue-header--info">
        <div class="pro-venue-header--info__content">
          <span class="title">
            {{ venueStore.details?.name }}
          </span>
          <span class="address">
            {{ venueStore.details.address }}
            <span v-if="!hasCityInAddress">
              {{ venueStore.details.city?.name }}
            </span>
          </span>
          <span class="schedule"></span>
          <div class="flex-row flex-wrap mb-8 hidden lg:flex">
            <span class="description truncated">
              {{ venueStore.details.description }}
            </span>
            <span
              v-if="isTruncated"
              class="see-more"
              @click="isDescriptionOpen = true"
            >
              {{ $t("provenue.more") }}
            </span>
          </div>
        </div>
        <pro-venue-spotify-widget
          v-if="
            venueStore.details.has_provenue &&
              venueStore.details.provenue_details &&
              venueStore.details.provenue_details.spotify_url
          "
          class="hidden lg:block"
          :playlist="venueStore.details.provenue_details.spotify_url"
        />
        <span class="lg:hidden block followers-mobile text-xs mb-2"
          >{{ venueStore.details.followers_count }}
          {{ $t("profiles.labels.followers") }}</span
        >
        <div class="pro-venue-header--info__actions">
          <div class="actions">
            <img
              class="lg:hidden block"
              src="@/assets/images/ic-empty-heart-rounded-topaz.svg"
              alt=""
            />
            <img
              class="lg:hidden block"
              src="@/assets/images/ic-description-rounded.svg"
              alt=""
              @click="isDescriptionOpen = true"
            />
            <img
              src="@/assets/images/ic-followers-circle-topaz.svg"
              :alt="$t('wegow.profile.alt.follow')"
              @click="goTo('followers')"
            />
            <img
              src="@/assets/images/ic-chat-circle-topaz.svg"
              alt=""
              @click="goTo('chat')"
            />
            <img
              src="@/assets/images/ic-share-circle-topaz.svg"
              :alt="$t('wegow.profile.alt.share')"
              @click="isShareOpen = true"
            />
          </div>
          <div class="followers">
            <follow-button
              type="venue"
              :item="venueStore.details"
              theme="follow-profile-btn"
            />
            <span class="followers">
              {{ venueStore.details.followers_count }}
              {{ $t("profiles.labels.followers") }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <pro-venue-description-dialog
    :show-dialog="isDescriptionOpen"
    :description="venueStore.details.description"
    @close="isDescriptionOpen = false"
  />
  <modal-share
    v-if="isShareOpen"
    category="event"
    @close="isShareOpen = false"
  ></modal-share>
</template>

<script setup>
import FollowButton from "../../FollowButton.vue";
import ProVenueSpotifyWidget from "./ProVenueSpotifyWidget.vue";
import ProVenueDescriptionDialog from "./ProVenueDescriptionDialog.vue";
import ModalShare from "../../modals/ModalShare.vue";
import { useVenueStore } from "@/stores/modules/venue";
import { ref, computed } from "vue";

const emit = defineEmits(["navigate"]);

const venueStore = useVenueStore();
const isExpanded = ref(false);
const isDescriptionOpen = ref(false);
const isShareOpen = ref(false);

// Computed property to check if the description is truncated
const isTruncated = computed(
  () =>
    venueStore.details &&
    venueStore.details.description &&
    venueStore.details.description.length > 100
); // Ajusta el número de caracteres según el texto

const hasCityInAddress = computed(() => {
  if (venueStore.details?.address && venueStore.details.city) {
    return (
      venueStore.details &&
      venueStore.details.address.includes(venueStore.details.city.name)
    );
  } else {
    return false;
  }
});
const getVenueImageUrl = () => {
  if (venueStore.details.image_url) {
    return venueStore.details.image_url;
  }
  return require("@/assets/images/placeholder-venue.svg");
};

const getVenueBackgroundImageUrl = () => {
  if (venueStore.details.image_url) {
    return `url(${venueStore.details.image_url})`;
  }
  return require("@/assets/images/placeholder-venue.svg");
};

const goTo = target => {
  emit("navigate", target);
};

const navigateToSpotifyLink = () => {
  if (
    venueStore.details.provenue_details &&
    venueStore.details.provenue_details.spotify_url
  ) {
    window.open(venueStore.details.provenue_details.spotify_url, "_blank");
  }
};
</script>

<style lang="scss" scoped>
.pro-venue-header-container {
  position: relative; /* Necesario para el posicionamiento absoluto dentro del contenedor */
  display: flex;
  justify-content: center;
}

.bg-image {
  @apply lg:h-[440px] h-[164px];
  display: block;
  position: relative;
  width: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  // & > img {
  //   @apply lg:h-[440px] h-[164px];
  //   width: 100%;
  //   opacity: 0.5;
  // background-position: center center;
  // background-repeat: no-repeat;
  // background-size: cover;
  // }
  &--overlay {
    @apply lg:h-[440px] h-[164px];
    z-index: 1;
    width: 100%;
    position: absolute;
    bottom: 0;
    opacity: 0.5;
    background-color: #000214;
  }
}

.pro-venue-header {
  @apply lg:pl-0 lg:pr-0 md:pl-[12px] md:pr-[62px];
  position: absolute;
  align-items: center;
  z-index: 1;
  top: 0;
  height: 100%;
  max-width: 65rem;
  width: 100%;
  margin: auto;
  display: grid;
  grid-template-columns: auto auto;
  gap: 30px;
  @media screen and (min-width: $screen-md) {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  &--img {
    @apply lg:w-[380px] w-[128px] lg:h-[380px] h-[128px];
    & > .venue-img-container > .venue-img {
      @apply lg:h-[380px] h-[128px] w-[128px] lg:w-[380px];
      border-radius: 10px;
      display: block;
    }
  }

  &--info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &__content {
      display: flex;
      flex-direction: column;
      & > .title {
        @apply lg:text-2xl text-base font-bold;
      }

      & > .address {
        @apply lg:text-base text-xs lg:my-0 my-[4px];
        color: $topaz;
      }

      & > .schedule {
        @apply hidden lg:block;
        margin-top: 15px;
      }

      /* Estilo de la descripción */
      & > div > .description {
        width: 90%;
        margin-top: 15px;
        display: -webkit-box;
        -webkit-line-clamp: 2; /* Limita a dos líneas */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: all 0.3s ease-in-out;
      }

      /* Si se expande el texto */
      & > div > .description.truncated {
        -webkit-line-clamp: 2;
      }

      /* Estilo del botón "Ver más" */
      & > div > .see-more {
        @apply lg:mt-[41px] mt-0;
        color: $topaz;
        cursor: pointer;
        font-size: 15px;
        transition: color 0.3s ease;
      }
    }
    &__actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;
      & > .actions {
        display: flex;
        gap: 8px;
        & > img {
          @apply h-[32px] lg:h-[41px];
          cursor: pointer;
        }
      }
      & > .followers {
        @apply hidden lg:flex;
        font-size: 20px;
        gap: 23px;
        align-items: center;
      }
    }
  }
}

/* Degradado superior */
.gradient-top {
  border-radius: 10px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 25%; /* Ajusta según el tamaño del degradado */
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), transparent);
  pointer-events: none; /* Evita interferir con los clics */
}

.venue-img {
  display: block;
  width: 100%;
  border-radius: 10px;
}

/* Degradado inferior */
.gradient-bottom {
  border-radius: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 25%; /* Ajusta según el tamaño del degradado */
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
  pointer-events: none;
}

/* Degradado superior */
.gradient-top-no-radius {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 25%; /* Ajusta según el tamaño del degradado */
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), transparent);
  pointer-events: none; /* Evita interferir con los clics */
}

/* Degradado inferior */
.gradient-bottom-no-radius {
  position: absolute;
  bottom: -3px;
  left: 0;
  right: 0;
  height: 25%; /* Ajusta según el tamaño del degradado */
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
  pointer-events: none;
}
</style>
